// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
import React, { useContext, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthProvider';
import { filterNavItemsForRole } from './roleAccess';

const navItems = [
  {
    section: 'User Management',
    icon: <i className="fas fa-user" />,
    items: [
      { label: 'Manage All Users', to: '/career-associates/' },
      { label: 'Career Associate-Manager Mappings', to: '/manager-mapping/' },
      { label: 'MFA Management', to: '/mfa-management' },
    ],
  },
  {
    section: 'Lead Management',
    icon: <i className="fas fa-users" />,
    items: [
      { label: 'Manage Leads', to: '/leads/' },
    ],
  },
  {
    section: 'Jobs Management',
    icon: <i className="fas fa-briefcase" />,
    items: [
      { label: 'Upload/Manage Jobs', to: '/manage-jobs/' },
      { label: 'Manage Job Roles', to: '/manage-job-roles/' },
    ],
  },
  {
    section: 'Task Management',
    items: [
      { label: 'View Tasks', to: '/view-tasks' },
      { label: 'Create Tasks For Lead', to: '/create-tasks-for-lead' },
      { label: 'Scoring Queue Summary', to: '/scoring-queue-dashboard/' },
      // { label: 'Create Tasks', to: '/create-tasks' },
      { label: 'Parsed Emails', to: '/parsed-emails' },
      { label: 'Lead-Career Associate Mapping', to: '/lead-career-associate-mapping' },
    ],
  },
  {
    section: 'Job Relevance Scoring',
    icon: (
      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="3" y="17" width="3" height="4" rx="1" fill="#6c7281" />
        <rect x="9" y="13" width="3" height="8" rx="1" fill="#6c7281" />
        <rect x="15" y="9" width="3" height="12" rx="1" fill="#6c7281" />
      </svg>
    ),
    items: [
      { label: 'Summary of Matched Jobs', to: '/job-scoring-summary/' },
      { label: 'View Candidate Matched Jobs', to: '/candidate-matched-jobs/' },
      { label: 'Lead Scored Jobs', to: '/lead-scored-jobs/' },
      { label: 'Trends Dashboard', to: '/trends-dashboard' },
    ],
  }
];

export default function Navbar() {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  // ⚠️ Adjust this line after you confirm where the role lives in your AuthProvider
  const role = user?.role || user?.role_name || user?.user_metadata?.role || '';

  // normalize trailing slashes for active-state comparison
  const normalize = (p) => (p || '').replace(/\/ $/, '');

  const itemsForRole = useMemo(() => filterNavItemsForRole(navItems, role), [role]);
  
	const [openSections, setOpenSections] = React.useState({
    'User Management': true,
    'Lead Management': false,
    'Jobs Management': false,
    'Task Management': false,
  });

  const toggleSection = section => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <aside className="w-full md:w-64 bg-white shadow-md border-r">
      <div className="p-6 flex items-center gap-2">
        <img src="/static/images/logo.png" className="h-8 w-8" alt="Logo" />
        <span className="text-lg font-bold">APPLY WIZZ</span>
      </div>
      <nav className="px-4 py-2 text-sm">
        <div className="flex flex-col">
          {/* {navItems.map(section => ( */}
           {itemsForRole.map(section => (
            <div key={section.section} className="mb-4">
              <button
                className="w-full flex items-center font-semibold text-gray-700 mb-2 focus:outline-none"
                onClick={() => toggleSection(section.section)}
              >
                <span className="mr-2">
                  {section.section === 'User Management' && <i className="fas fa-user" />}
                  {section.section === 'Lead Management' && <i className="fas fa-users" />}
                  {section.section === 'Jobs Management' && <i className="fas fa-briefcase" />}
                  {section.section === 'Task Management' && <i className="fas fa-ellipsis-h" />}
                </span>
                {section.section}
                <span className="ml-auto">{openSections[section.section] ? '▾' : '▸'}</span>
              </button>
              {openSections[section.section] && (
                <ul className="space-y-1 pl-6 mt-2">
                  {section.items.map(item => (
                    <li key={item.to}>
                      <Link
                        to={item.to}
                        // className={`block px-3 py-2 rounded-md ${location.pathname === item.to ? 'text-indigo-600 bg-indigo-50 font-medium' : 'text-gray-700 hover:bg-gray-100'}`}                        
                        className={`block px-3 py-2 rounded-md ${normalize(location.pathname) === normalize(item.to) ? 'text-indigo-600 bg-indigo-50 font-medium' : 'text-gray-700 hover:bg-gray-100'}`}
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </nav>
    </aside>
  );
}
